var exports = {
  "az": "Box__My5Mrb",
  "EY": "Text__ZQOMWw",
  "UE": "Text_1__xjFMbR",
};

module.exports = exports;
